<template>
    <view class="index-wrapper">
        <!-- 自定义tabbar -->
        <!-- <uni-nav-bar color="#fff" :statusBar="true" leftWidth="150rpx" background-color="#44ad85" :fixed="true" title="怡享到家">
			<template v-slot:left>
			    <view class="leftbar">
			    	<view class="city" @click="$refs.pickerPop.open('bottom')">
			    		<view class="city_name"><text style="font-size: 26upx">{{myCityInfo.name || "未知城市"}}</text></view>
			    		<uni-icons type="arrowdown" color="#fff" size="14" />
			    	</view>
			    </view>
			  </template>
		</uni-nav-bar> -->
        <uni-popup ref="pickerPop">
            <city-picker @changeCity="changeCity"></city-picker>
        </uni-popup>

        <!-- 轮播图 -->
        <view class="swiper_contianer">
            <swiper
                class="swiper"
                autoplay
                interval="2000"
                :current="currentBanner"
                circular
                @change="bannerChange"
            >
                <swiper-item v-for="(item, index) in swiperList" :key="item.id">
                    <image @click="toApplyMaster(index)" :src="item.img"></image>
                </swiper-item>
            </swiper>
            <view class="customDots flex">
                <view
                    class="dot"
                    :class="{ active: index === currentBanner }"
                    v-for="(item, index) in swiperList"
                    :key="item.id"
                >
                </view>
            </view>
        </view>
        <!-- 点击排序区域 -->
        <!-- <view class="option_container">
			<picker mode="selector" class="row picker" @click="change(11)" @change="changeCate" :value="cateIndex" :range="cateList" range-key="title">
				<view class="row">
					<text v-if="cateList.length">{{cateList[cateIndex].title || '分类'}}</text>
					<text v-else>分类</text>
					<view class="row_right">
						<view class="triangle_down"></view>
					</view>
				</view>
			</picker>
			<view :class="['row',goodsPage.order == 11?'select':'']" @click="change(11)">
				<text>默认</text>
				<view class="row_right">
					<view :class="['triangle_down',goodsPage.order == 11?'select_down':'']"></view>
				</view>
				<view :class="['row_line',goodsPage.order == 11?'':'hide']"></view>
			</view>
			<view :class="['row',goodsPage.order == 33?'select':'']" @click="change(33)">
				<text>价格</text>
				<view class="row_right">
					<view :class="['triangle_down',goodsPage.order == 33?'select_down':'']"></view>
				</view>
			</view>
			<view :class="['row',goodsPage.order == 55?'select':'']" @click="change(55)">
				<text>单量</text>
				<view class="row_right">
					<view :class="['triangle_down',goodsPage.order == 55?'select_down':'']"></view>
				</view>
			</view>
			<view :class="['row',goodsPage.order == 77?'select':'']" @click="change(77)">
				<text>好评</text>
				<view class="row_right">
					<view :class="['triangle_down',goodsPage.order == 77?'select_down':'']"></view>
				</view>
			</view>
		</view> -->
        <!-- list  列表区域 -->
        <view class="list_warp">
            <block v-if="goodsList.length">
                <view
                    class="item"
                    @click="toItemDetail(item.id)"
                    v-for="(item, index) in goodsList"
                    :key="index"
                >
                    <view class="item_img">
                        <image :src="item.logo" mode="aspectFit"></image>
                    </view>
                    <view class="item_container">
                        <view class="item_info">
                            <view class="title">{{ item.title }}</view>
                            <view class="detaile">
                                <text>{{ item.sub_title }}</text>
                            </view>
                            <view class="price">
                                <text class="money">{{ item.price }}</text
                                ><text class="cred">元</text> {{ item.duration }}分钟
                            </view>
                            <view class="price_warp">
                                <view class="select_people_count"
                                    ><image src="../../static/img/yiyou.png"></image>已有{{
                                        item.sales_num
                                    }}人选择</view
                                >
                            </view>
                            <view class="handleBtn" @click.stop="toIndexMaster(item.id)"
                                >选理疗师</view
                            >
                        </view>
                        <!-- <view class="item_btn">
						</view> -->
                    </view>
                </view>
            </block>
            <block v-else>
                <view class="empty_master">
                    <image src="../../static/logo.png" mode="widthFix"></image>
                    <text class="empty">暂无服务</text>
                </view>
            </block>
            <!-- <view class="empty" v-if="goodsList.length && isNull">
				我是有底线的~
			</view> -->
        </view>

        <Danger v-if="isCallShow" />
        <!-- #ifdef APP-PLUS -->
        <CheckVersion />
        <!-- #endif -->
    </view>
</template>

<script setup>
import { computed, ref, reactive } from 'vue'
import { onLoad, onPullDownRefresh, onShareAppMessage, onReachBottom } from '@dcloudio/uni-app'
import { setStorage, getStorage } from '@/service/storage'
import { useStore, mapGetters } from 'vuex'
import Danger from '../../components/danger.vue'
import cityPicker from '../../components/cityPicker.vue'
import CheckVersion from '../../components/checkVersion.vue'
import { useGetGlobalProperties } from '@/utils/hooks.js'
import { updateText } from '@/utils/config.js'

const global = useGetGlobalProperties()
const store = useStore()
const userInfo = computed(() => store.getters.userInfo)
const isCallShow = computed(() => store.getters.isCallShow)
const platform = ref('')

onLoad(options => {
    getBanner()
    getCateList()
    // console.log('首页初次加载', options)
    if (userInfo.value.id) {
        store.dispatch('isExistOrder')
        store.dispatch('getUser')
    }
    if (options.pid) {
        setStorage('pid', options.pid)
    }
    if (options.agent_pid) {
        setStorage('agent_pid', options.agent_pid)
    }
    uni.getSystemInfo({
        success: e => {
            platform.value = e.platform
            // console.log(this.platform,"运行平台")
        }
    })
    initLoad()
})

const initLoad = async () => {
    getGoodsList()
    if (myCityInfo.value && myCityInfo.value.id) {
        getGoodsList()
    } else {
        uni.showLoading({
            title: '获取定位中...'
        })
        // #ifdef APP-PLUS
        if (global.isAndroid) {
            const [err, version] = await global.$api.Version({
                type_limit: 11
            })
            if (version && version.code == 10000) {
                if (version.data[2].system_value == updateText) {
                    const cityList = store.state.cityList
                    const mycity =
                        cityList.length && cityList[0].sub.length
                            ? cityList[0].sub[0]
                            : { id: 3, name: '重庆' }
                    setStorage('myCityInfo', mycity)
                    store.state.myCityInfo = mycity
                    getGoodsList()
                    return
                }
            }
        }
        // #endif
        if (uni.getStorageSync('init') == 1) {
            uni.getLocation({
                type: 'gcj02',
                success: res => {
                    uni.hideLoading()
                    console.log('获取到地址--------', res)
                    store.state.longitude = res.longitude
                    store.state.latitude = res.latitude
                    setStorage('longitude', res.longitude)
                    setStorage('latitude', res.latitude)
                    let locationStr = res.latitude + ',' + res.longitude

                    searchCity(locationStr).then(res => {
                        if (res) {
                            getGoodsList()
                        } else {
                            const cityList = store.state.cityList
                            const mycity =
                                cityList.length && cityList[1].sub.length
                                    ? cityList[1].sub[0]
                                    : { id: 6, name: '贵阳' }
                            setStorage('myCityInfo', mycity)
                            store.state.myCityInfo = mycity
                            getGoodsList()
                            uni.showToast({
                                title:
                                    '您所在的城市暂未开通服务，系统将默认加载' +
                                    mycity.name +
                                    '的服务项目',
                                icon: 'none',
                                duration: 3000
                            })
                        }
                    })
                },
                fail: err => {
                    setStorage('hasLocation', 0)
                    uni.hideLoading()
                    console.log('定位出错：', err)
                    const cityList = store.state.cityList
                    const mycity =
                        cityList.length && cityList[0].sub.length
                            ? cityList[0].sub[0]
                            : { id: 6, name: '贵阳' }
                    setStorage('myCityInfo', mycity)
                    store.state.myCityInfo = mycity
                    getGoodsList()
                },
                complete() {
                    uni.setStorageSync('init', 1)
                }
            })
        } else {
            uni.showModal({
                title: '获取定位',
                content: '获取用户所在位置用于填写用户的详细地址，根据用户所在位置匹配附近的技师。',
                success: res => {
                    res.confirm &&
                        uni.getLocation({
                            type: 'gcj02',
                            success: res => {
                                uni.hideLoading()
                                console.log('获取到地址--------', res)
                                store.state.longitude = res.longitude
                                store.state.latitude = res.latitude
                                setStorage('longitude', res.longitude)
                                setStorage('latitude', res.latitude)
                                let locationStr = res.latitude + ',' + res.longitude

                                searchCity(locationStr).then(res => {
                                    if (res) {
                                        getGoodsList()
                                    } else {
                                        const cityList = store.state.cityList
                                        const mycity =
                                            cityList.length && cityList[1].sub.length
                                                ? cityList[1].sub[0]
                                                : { id: 6, name: '贵阳' }
                                        setStorage('myCityInfo', mycity)
                                        store.state.myCityInfo = mycity
                                        getGoodsList()
                                        uni.showToast({
                                            title:
                                                '您所在的城市暂未开通服务，系统将默认加载' +
                                                mycity.name +
                                                '的服务项目',
                                            icon: 'none',
                                            duration: 3000
                                        })
                                    }
                                })
                            },
                            fail: err => {
                                setStorage('hasLocation', 0)
                                uni.hideLoading()
                                console.log('定位出错：', err)
                                const cityList = store.state.cityList
                                const mycity =
                                    cityList.length && cityList[0].sub.length
                                        ? cityList[0].sub[0]
                                        : { id: 6, name: '贵阳' }
                                setStorage('myCityInfo', mycity)
                                store.state.myCityInfo = mycity
                                getGoodsList()
                            },
                            complete() {
                                uni.setStorageSync('init', 1)
                            }
                        })
                }
            })
        }
    }
}
const searchCity = async location => {
    const [err, res] = await global.$api.searchCity({ location })
    console.log('aaa', res.data)
    setStorage('myCityInfo', res.data)
    store.state.myCityInfo = res.data
}
// 自定义头部栏
const myCityInfo = computed(() => store.getters.myCityInfo)
const pickerPop = ref(null)
const changeCity = e => {
    if (e == 1) {
        getGoodsList()
        pickerPop.value.close()
    } else {
        pickerPop.value.close()
    }
}

// 轮播图
const currentBanner = ref(0)
const swiperList = ref([])
const bannerChange = ({ detail }) => {
    currentBanner.value = detail.current
}
// 获取轮播图
const getBanner = async () => {
    const [err, res] = await global.$api.getBanner()
    if (err) {
        return global.$toast('获取轮播图异常,请刷新重试')
    }
    console.log('轮播图', res)
    swiperList.value = res.data
}
const toApplyMaster = index => {
    if (!userInfo.value.id && (index == 0 || index == 1))
        return uni.navigateTo({
            url: '../login/login',
            success: () => {
                global.$toast('请先登录')
            }
        })
    if (index == 0) {
        if (userInfo.value.t_id) {
            global.$toast('您已经是技师了')
        } else {
            uni.navigateTo({
                url: '../my/applyMaster/applyMaster'
            })
        }
    }
    if (index == 1) {
        uni.navigateTo({
            url: './tousu/tousu'
        })
    }
}

// 项目区域
const goodsPage = reactive({
    page: 1, //页码
    limit: 10, //每页条数
    order: '11', //排序
    area_id: '',
    cate_id: ''
})
const goodsList = ref([])
const isNull = ref(false)
//点击选项
const change = index => {
    if (goodsPage.order == index) return
    goodsPage.order = index
    getGoodsList()
}
// 获取商品列表
const getGoodsList = async () => {
    uni.showLoading({ title: '加载中' })
    goodsPage.area_id = myCityInfo.value.id
    const [_, res] = await global.$api.getGoodsList(goodsPage)
    uni.hideLoading()
    uni.stopPullDownRefresh()
    // console.log(res)
    if ((res.code = 10000)) {
        goodsList.value = goodsPage.page == 1 ? res.data : [].concat(goodsList.value, res.data)
        isNull.value = res.data.length < goodsPage.limit
    } else {
        isNull.value = false
    }
}
//跳转至项目详情
const toItemDetail = async id => {
    uni.navigateTo({
        url: `./itemDetail/itemDetail?id=${id}`
    })
}
const toIndexMaster = async id => {
    uni.navigateTo({
        url: `./indexMaster/indexMaster?id=${id}`
    })
}

const cateList = ref([]) // 分类列表
const cateIndex = ref(0)
async function getCateList() {
    const [err, res] = await global.$api.cate_lists()
    if (err) {
        return global.$toast('获取分类异常,请刷新重试')
    }
    cateList.value = [].concat([{ title: '全部', id: '' }], res.data)
}
function changeCate({ detail }) {
    cateIndex.value = detail.value
    goodsPage.cate_id = cateList.value[detail.value].id || ''
    getGoodsList()
}
//下拉刷新
onPullDownRefresh(() => {
    goodsPage.page = 1
    isNull.value = false
    getBanner()
    getCateList()
    getGoodsList()
    setTimeout(() => {
        uni.stopPullDownRefresh()
    }, 1000)
})
//上拉加载更多
onReachBottom(() => {
    if (!isNull.value) {
        goodsPage.page += 1
        getGoodsList()
    }
})
onShareAppMessage(() => {})
</script>
<style lang="less" scoped>
page {
    // background-color: #F4F8F7;
}
.city {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 8upx;
    min-width: 220upx;

    .city_name {
        margin-right: 10upx;
    }
}
/deep/ .uni-navbar--border {
    border: none;
}

.swiper_contianer {
    // padding: 20upx;
    overflow: hidden;
    height: 320upx;
    .swiper {
        // height: 326.1upx;
        // width: 710upx;
        height: 320upx;
        // height: calc(750rpx / 2.3);
        border-radius: 16upx;
        overflow: hidden;

        image {
            height: 100%;
            width: 100%;
            border-radius: 16upx;
        }
    }
    .new_index_bg {
        width: 100%;
        .new_bg {
            position: absolute;
            left: 0;
            width: 100%;
            top: 0;
            image {
                width: 100%;
            }
        }
    }
    .customDots {
        width: 100%;
        justify-content: center;
        margin-top: -30upx;
        z-index: 20;
        position: relative;

        .dot {
            width: 8rpx;
            height: 8rpx;
            background: rgba(255, 255, 255, 0.39);
            opacity: 0.5;
            border-radius: 4rpx;
            margin: 0 10upx;
            transition: width 0.3s;

            &.active {
                opacity: 0.9;
                width: 20rpx;
                background: #fff;
            }
        }
    }

    .flex {
        display: flex;
    }
}

.option_container {
    background-color: #fff;
    display: flex;
    font-size: 24upx;
    // font-weight: 600;
    justify-content: space-around;
    border-bottom: 1px solid #e6e6e6;
    height: 93rpx;
    .sort {
        display: flex;
        flex-direction: column;
        // margin-right: 60upx;

        .row_line {
            width: 100%;
            height: 8upx;
            background: #44ad85;
            margin-top: 16upx;
            border-radius: 10upx;

            &.hide {
                background-color: transparent;
            }
        }
    }

    .row {
        display: flex;
        align-items: center;
        text {
            white-space: nowrap;
        }
        &.picker {
            // width: 100rpx;
            .row {
            }
        }
        &.select {
            color: #44ad85;
        }

        .row_right {
            width: 28upx;
            margin-left: 8upx;
            // margin-right: 60upx;
            margin-top: 6upx;
            display: flex;
            align-items: center;

            .triangle_down {
                width: 0;
                margin-left: 8upx;
                height: 0;
                border-left: 7upx solid transparent;
                border-right: 7upx solid transparent;
                border-top: 12upx solid #e9e9e9; //#E9E9E9
            }

            .select_down {
                border-top: 12upx solid #44ad85;
            }
        }
    }
}

.list_warp {
    background-color: #f4f8f7;
    .item {
        background-color: #fff;
        width: 100%;
        // height: 50upx;
        display: flex;
        // box-shadow: 0upx 4upx 8upx 2upx rgba(0, 0, 0, 0.05);
        // border-radius: 8upx;
        margin-bottom: 6upx;
        padding: 30rpx 30rpx 20rpx;
        .item_img {
            margin-right: 20upx;
            position: relative;
            width: 180rpx;
            height: 210rpx;
            border-radius: 10rpx;
            background-color: #f4f8f7;
            image {
                width: 100%;
                height: 100%;
                overflow: hidden;
            }
        }

        .item_container {
            flex: 1;
            display: flex;

            .item_info {
                // margin: 13upx 0;
                display: flex;
                flex: 1;
                flex-direction: column;
                justify-content: space-between;
                font-size: 26upx;
                // margin-right: 32upx;
                position: relative;

                .title {
                    font-size: 28rpx;
                    font-family: PingFang SC;
                    font-weight: bold;
                    line-height: 40rpx;
                    color: #343434;
                }

                .detaile {
                    width: auto;
                    display: flex;
                    opacity: 1;
                    border-radius: 4rpx;
                    font-size: 24rpx;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #44ad85;
                    // margin-top: 10rpx;
                    text {
                        display: flex;
                        align-items: center;
                        height: 43rpx;
                        padding: 0 10rpx;
                        background: rgba(228, 246, 240, 0.39);
                    }
                }
                .select_people_count {
                    display: flex;
                    align-items: center;
                    font-size: 26upx;
                    color: #666666;
                    height: 34rpx;
                    image {
                        width: 25rpx;
                        height: 25rpx;
                        margin-right: 8rpx;
                    }
                }
                .price {
                    font-size: 24rpx;
                    color: #666666;
                    .money {
                        color: #ff0000;
                        font-size: 36upx;
                    }
                    .cred {
                        color: #ff0000;
                        margin-right: 10upx;
                    }
                }
                .handleBtn {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 174rpx;
                    height: 63rpx;
                    background: #44ad85;
                    opacity: 1;
                    border-radius: 32rpx;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    font-size: 26rpx;
                }
            }

            // .item_btn {
            // 	flex: 1;
            // 	margin-top: 52upx;
            // 	display: flex;
            // 	align-items: flex-end;
            // 	justify-content: flex-end;

            // }
        }
    }
}

.flex {
    display: flex;
}

.flexALign {
    display: flex;
    align-items: center;
}

.dialog {
    position: relative;
    width: 640upx;
    height: 750upx;
    padding: 36upx;
    background: #ffffff;
    border-radius: 20upx;
    flex-direction: column;

    .title {
        font-size: 36upx;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        text-align: center;
        padding-bottom: 18upx;
        padding-top: 0upx !important;
        font-family: PingFangSC-Semibold, PingFang SC;
    }

    .content {
        // height: 614upx;
        font-size: 30upx;
        font-family: PingFangSC-Light, PingFang SC;
        color: rgba(0, 0, 0, 0.85);
        line-height: 62upx;

        p {
            text-indent: 2em;
        }

        .text_color {
            color: #44ad85;
        }
    }

    .text {
        font-size: 30upx;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.1);
        padding-top: 44upx;
    }

    .bar {
        position: absolute;
        width: 100%;
        height: 82upx;
        border-top: 2upx solid #e5e5e5;
        bottom: 0;

        .le {
            width: 50%;
            font-size: 32upx;
            text-align: center;
            line-height: 82upx;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(0, 0, 0, 0.5);
            border-right: 2upx solid #e5e5e5;
        }

        .ri {
            width: 50%;
            font-size: 32upx;
            text-align: center;
            line-height: 82upx;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #44ad85;
            // border-left: 1upx solid #E5E5E5;
        }
    }

    .submit {
        width: 496upx;
        height: 100upx;
        background: #09c4ad;
        border-radius: 50upx;
        font-size: 30upx;
        font-weight: 600;
        color: #ffffff;
        line-height: 100upx;
        text-align: center;
        margin-top: 74upx;
    }
}

.empty_master {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 200upx auto;
    // background-color: #fff;
    image {
        width: 30%;
        margin-bottom: 40upx;
    }
}

.picker_sure_warp {
    background-color: #ffffff;
    display: flex;
    justify-content: space-around;
    padding: 20upx 40upx;

    .picker_sure {
        width: 50%;
        text-align: right;
    }

    .picker_cancel {
        width: 50%;
    }
}

.picker-view {
    width: 750upx;
    height: 400upx;
    text-align: center;
    background-color: #ffffff;
}
</style>
